import React, { useEffect, useRef, useState } from "react";
import BusinessName from "../../components/BusinessName";
import Toggle from "../../components/Toggle";
import CameraPic from "../../assets/images/camera.png";
import { useNavigate } from "react-router-dom";
import { createPaymentLink, getCurrencies } from "../../services/settings";
import toast from "react-hot-toast";
import { useQueryClient } from "@tanstack/react-query";
import { useAuth } from "../../context/AuthContextProvider";

const CreateLink = () => {
  // const [profileInfo, setProfileInfo] = useState({});

  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [currency, setCurrency] = useState([]);
  const [currencyName, setCurrencyName] = useState("");
  const [selectedCurrency, setSelectedCurrency] = useState("");
  const [paymentLinkType, setPaymentLinkType] = useState("");
  const [amount, setAmount] = useState("");
  const [customerName, setCustomerName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [email, setEmail] = useState("");
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState("");
  const queryClient = useQueryClient();
  const [requireEmailAddress, setRequireEmailAddress] = useState(true);
  const [requirePhoneNumber, setRequirePhoneNumber] = useState(true);
  const [presetAmount, setPresetAmount] = useState(true);
  const [agreeTerms, setAgreeTerms] = useState(false);
  const [previewImage, setPreviewImage] = useState(null);
  const fileInputRef = useRef(null);
  const { globalProfile } = useAuth();

  const handlePhoneNumberChange = (e) => {
    let input = e.target.value;
    // Remove non-digit characters
    let digitsOnly = input.replace(/\D/g, "");
    // Restrict to 11 digits
    if (digitsOnly.length <= 11) {
      setPhoneNumber(digitsOnly);
    }
  };

  const handleAmountChange = (e) => {
    let input = e.target.value;
    let numbersOnly = input.replace(/[^0-9.]/g, ""); // Remove non-numeric characters except the decimal point

    // Ensure there's only one decimal point
    const decimalCount = (numbersOnly.match(/\./g) || []).length;
    if (decimalCount <= 1) {
      setAmount(numbersOnly);
    }
  };

  const handleCheckboxChange = (e, func) => {
    if (e.target.checked) {
      func(true);
    } else {
      func(false);
    }
  };

  const navigate = useNavigate();

  // const handlePaymentLink = () => {
  //     navigate("/payments/payment-links/payment-link");
  // };

  const handleReturn = () => {
    navigate("/payments/payment-links");
  };

  const handleImageChange = (e) => {
    const selectedFile = e.target.files[0];
    setFile(selectedFile);
    if (selectedFile) {
      const reader = new FileReader();
      reader.onload = () => {
        setPreviewImage(reader.result);
      };
      reader.readAsDataURL(selectedFile);
    }
  };

  const fetchCurrency = async () => {
    try {
      const res = await getCurrencies();
      setCurrency(res.data);
    } catch (error) {
      if (error.response) {
        toast.error(error.response.data.message);
      }
    }
  };

  const handleCurrency = (e) => {
    const selectedCurrencyId = e.target.value;
    setSelectedCurrency(selectedCurrencyId);

    const matchedCurrency = currency.find(
      (cur) => cur.code === selectedCurrencyId
    );
    const currencyName = matchedCurrency ? matchedCurrency.name : "";
    setCurrencyName(currencyName);
  };

  const handleImageClick = (e) => {
    fileInputRef.current.click();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // // You can now access the selected options
    // console.log("Selected options:", checkedOptions);

    setLoading(true);
    try {
      const formData = new FormData();
      formData.append("Title", title);
      formData.append("Description", description);
      formData.append("Currency", selectedCurrency);
      formData.append("name", currencyName);
      formData.append("PaymentLinkType", paymentLinkType);
      formData.append("Amount", amount);
      formData.append("CustomerName", customerName);
      formData.append("PhoneNumber", phoneNumber);
      formData.append("Email", email);
      formData.append("IsAmountPreset", presetAmount);
      formData.append("IstermsAgreed", agreeTerms);
      formData.append("IsPhoneNumberRequired", requirePhoneNumber);
      formData.append("IsEmailRequired", requireEmailAddress);
      formData.append("Image", file);

      const response = await createPaymentLink(formData);

      if (response.success) {
        // toast.success("Payment link created successfully");
        // navigate('/next-page'); // Replace '/next-page' with your desired route
        toast.success(response.message);
        setLoading(false);
        navigate(`/payments/payment-links/payment-link/${response.data}`);
      } else {
        const result = await response.json();
        toast.error(result.message || "Error creating payment link");
      }
    } catch (error) {
      if (error.response) {
        toast.error(error.response.data.message);
        // toast.error("File upload failed. Please try again.");
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    fetchCurrency();
  }, []);

  return (
    <div className="xl:w-full min-h-screen overflow-hidden">
      <div className="xl:flex xl:items-center xl:justify-between">
        <h1 className="text-2xl font-bold text-navy-blue">Payments - Links</h1>
        <Toggle />
      </div>

      {/* <section className="xl:flex justify-start xl:justify-end text-xl font-bold pt-4 mb-4 pr-4">
        <span className="ml-2">
          <BusinessName />
        </span>
      </section> */}

      <div className=" xl:h-[1300px]  h-auto bg-white max-w-72 md:max-w-full mt-8 rounded-[10px] md:p-[3rem]">
        <div className="border border-gray-200  rounded-t-[10px] p-[1rem] pl-7 flex justify-between items-center mb-8">
          <p className="text-primary text-xl font-semibold">
            Create Payment Link
          </p>
          <span>
            <svg
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M4.5 6.75L9 11.25L13.5 6.75"
                stroke="#464255"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </span>
        </div>

        <form
          className="xl:flex md:mt-0 mt-[-15rem] xl:flex-row flex flex-col-reverse min-h-screen"
          onSubmit={handleSubmit}
        >
          <section className="w-1/2 pl-[1.8rem] min-h-screen ">
            <div>
              <section className="">
                <article>
                  <div className=" pt-4">
                    <label>Payment Title</label>
                    <input
                      placeholder="Enter Title"
                      // value={businessName}
                      type="text"
                      className="lg:w-[348px] h-[50px] bg-gray-100 outline-none rounded-[.5rem]
                                         pl-[.5rem] flex justify-center items-center mt-3"
                      onChange={(e) => setTitle(e.target.value)}
                    />
                  </div>

                  <div className=" pt-4">
                    <label>Description</label>
                    <input
                      placeholder="Enter Description"
                      // value={businessName}
                      type="text"
                      className="lg:w-[348px] h-[50px] bg-gray-100 outline-none rounded-[.5rem]
                                         pl-[.5rem] flex justify-center items-center mt-3"
                      onChange={(e) => setDescription(e.target.value)}
                    />
                  </div>

                  <div className="pt-4">
                    <label for="currency">Account currency</label>
                    <select
                      className="lg:max-w-[348px] h-[50px] max-w-44 bg-gray-100 outline-none rounded-[.5rem]
                                         pl-[.5rem] flex justify-center items-center mt-3"
                      name="currency"
                      id="currency"
                      value={selectedCurrency}
                      onChange={handleCurrency}
                    >
                      <option value="">Select currency </option>
                      {currency.map((curr, index) => (
                        <option key={index} value={curr.code}>
                          {curr.name}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="flex flex-col pt-4">
                    <label htmlFor="options">Payment Link Type</label>
                    <select
                      className="lg:w-[348px] h-[50px] w-44 bg-gray-100 outline-none rounded-[.5rem]
                                         pl-[.5rem] flex justify-center items-center mt-3"
                      name="options"
                      id="options"
                      onChange={(e) => setPaymentLinkType(e.target.value)}
                      value={paymentLinkType}
                    >
                      <option value="" disabled>
                        Select payment type
                      </option>
                      <option value="Single">Single</option>
                      <option value="Multiple">Multiple</option>
                    </select>
                  </div>

                  <div className=" pt-4">
                    <label>Amount</label>
                    <input
                      type="text"
                      value={amount}
                      onChange={handleAmountChange}
                      placeholder="Enter amount"
                      className="lg:w-[348px] h-[50px] bg-gray-100 outline-none rounded-[.5rem]
                                            pl-[.5rem] flex justify-center items-center mt-3"
                      // onChange={(e) => setAmount(e.target.value)}
                      // onChange={handleAmountChange}
                    />
                  </div>

                  <div className=" pt-4">
                    <label>Customer name</label>
                    <input
                      placeholder="Enter Customer name"
                      // value={businessName}
                      type="text"
                      className="lg:w-[348px] h-[50px] bg-gray-100 outline-none rounded-[.5rem]
                                         pl-[.5rem] flex justify-center items-center mt-3"
                      onChange={(e) => setCustomerName(e.target.value)}
                    />
                  </div>

                  {/* <div className=" pt-4">
                    <label>Phone number</label>
                    <input
                      type="text"
                      value={phoneNumber}
                      onChange={handlePhoneNumberChange}
                      placeholder="Enter phone number"
                      maxLength="11" // Optional, but our function restricts this
                      className="lg:w-[348px] h-[50px] bg-gray-100 outline-none rounded-[.5rem]
                                         pl-[.5rem] flex justify-center items-center mt-3"
                      // onChange={(e) => setPhoneNumber(e.target.value)}
                    />
                  </div> */}

                  {/* <div className=" pt-4">
                    <label>Email</label>
                    <input
                      type="email"
                      placeholder="Enter email"
                      className="lg:w-[348px] h-[50px] bg-gray-100 outline-none rounded-[.5rem]
                                         pl-[.5rem] flex justify-center items-center mt-3"
                      onChange={(e) => setEmail(e.target.value)}
                    />
                  </div> */}
                </article>

                <div className="mt-8">
                  <section>
                    <label
                      className="container"
                      style={{ fontSize: "14px", fontWeight: 400 }}
                    >
                      Make this amount preset.
                      <input
                        type="checkbox"
                        name="presetAmount"
                        checked={presetAmount}
                        onChange={(e) =>
                          handleCheckboxChange(e, setPresetAmount)
                        }
                      />
                      <span className="checkmark"></span>
                    </label>
                  </section>

                  <section>
                    <label
                      className="container"
                      style={{ fontSize: "14px", fontWeight: 400 }}
                    >
                      Agree to terms and condition of payloft as regards payment
                      links
                      <input
                        type="checkbox"
                        name="agreeTerms"
                        checked={agreeTerms}
                        onChange={(e) => handleCheckboxChange(e, setAgreeTerms)}
                      />
                      <span className="checkmark"></span>
                    </label>
                  </section>
                </div>
              </section>
            </div>

            <div className="flex flex-col md:flex-row gap-4 mt-10">
              <button
                className="md:w-[142px] w-full text-primary border border-primary p-2 rounded-md"
                onClick={handleReturn}
              >
                Cancel
              </button>

              <button
                className={`md:w-[272px] w-full text-white p-2 rounded-md ${
                  agreeTerms
                    ? "bg-primary"
                    : "bg-[rgba(var(--primary-rgb),0.5)] cursor-not-allowed"
                }`}
                disabled={!agreeTerms}
              >
                Create Link
              </button>
              {/* 
                            <button
                                className="w-[272px] bg-orange-400  p-2 rounded-md"
                            // onClick={handleSubmit}
                            >
                                Create Link
                            </button> */}
            </div>
          </section>

          <section className="w-1/2 flex flex-col">
            <input
              type="file"
              id="upload"
              name="upload"
              accept="image/*"
              className="hidden"
              ref={fileInputRef}
              onChange={handleImageChange}
            />

            <div className="md:w-[212px]  md:h-[174px] md:mt-0 mt-[15rem]  flex flex-col items-center justify-center relative">
              {previewImage ? (
                <img
                  src={previewImage}
                  alt="Preview"
                  className="w-[114px] h-[114px] rounded-full"
                  onClick={handleImageClick}
                />
              ) : (
                <div className="flex bg-gray-500/15 rounded-full md:mt-0 mt-3 pb-7 gap-2 flex-col items-center w-[114px] h-[114px] relative">
                  <img
                    src={CameraPic}
                    alt="preview"
                    className="w-[38.4px] h-[31.74px] absolute top-9 right-9"
                    onClick={handleImageClick}
                  ></img>
                </div>
              )}
            </div>
            <p>* The uploaded image must be 500px wide and 500px long</p>

            <div className="flex flex-col w-[352px] gap-5 ">
              <p className="flex items-center gap-2 text-[20px] font-[400]">
                Advanced Options
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M13.5 12L9 7.5L4.5 12"
                    stroke="#464255"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </p>

              <div className="flex items-center px-2 gap-2">
                <p className="font-semibold">Pay</p>
                <span className="font-semibold">as the call to action</span>
              </div>

              <div className="max-w-60 ml-2">
                <label
                  className="container"
                  style={{ fontSize: "14px", fontWeight: 400 }}
                >
                  Require customers to provide phone number
                  <input
                    type="checkbox"
                    name="requirePhoneNumber"
                    checked={requirePhoneNumber}
                    onChange={(e) =>
                      handleCheckboxChange(e, setRequirePhoneNumber)
                    }
                  />
                  <span className="checkmark"></span>
                </label>

                <label
                  className="container"
                  style={{ fontSize: "14px", fontWeight: 400 }}
                >
                  Require customers to provide email address
                  <input
                    type="checkbox"
                    name="requireEmailAddress"
                    checked={requireEmailAddress}
                    onChange={(e) =>
                      handleCheckboxChange(e, setRequireEmailAddress)
                    }
                  />
                  <span className="checkmark"></span>
                </label>
              </div>
            </div>
          </section>
        </form>
      </div>
    </div>
  );
};

export default CreateLink;
